import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const infoContentStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '16px'
}

const TestConfigScriptedParameterDefaultValueInfo = () =>
  <div style={infoContentStyle}>
    <Paragraph>
      <Color variant='theme-description-text'>
        The default parameter value is taken from the test case. If there are no parameter values set in test case, there will be no default value.
      </Color>
    </Paragraph>
    <Paragraph>
      <LinkToDocusaurus path='dai-test-configuration'>
        Learn more in the the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </div>

export default TestConfigScriptedParameterDefaultValueInfo
